import gql from 'graphql-tag'

export const GET_LESSON_AVAILABLE_TIMES = gql`
  query CoachProfileLessonAvailableTimes(
    $id: ID
    $startDateTime: ISO8601DateTime
    $endDateTime: ISO8601DateTime
    $limit: Int
  ) {
    lessonTypes(id: $id) {
      id
      availableTimes(
        startDateTime: $startDateTime
        endDateTime: $endDateTime
        limit: $limit
      ) {
        startDateTime
        locationId
      }
      facilities {
        id
        name
        city
        state
        timezone
      }
    }
  }
`
